import { getUserMaterialTag } from '@/api/myGallery/index'

const myGallery = {
  state: {
    allTags: [],
    activeUser: ''
  },
  actions: {
    GetUserMaterialTag({ commit }, data) {
      getUserMaterialTag(data).then(res => {
        commit('SET_ALL_TAGS', res.data)
      })
    }
  },
  mutations: {
    SET_ALL_TAGS: (state, data) => {
      state.allTags = data
    },
    SET_ACTIVE_USER: (state, data) => {
      state.activeUser = data
    }
  }
}

export default myGallery
